<div class="embedded-layout">
  <ocp-header>
    <ocp-breadcrumb [minified]="true" />
    <div class="embedded-layout__header-actions">
      <ocp-open-in-browser-button (clicked)="onOpenInBrowser()" />
      <hlm-popover #popover="hlmPopover" #popoverEl [attachTo]="popoverEl">
        <ocp-avatar
          [userInitials]="userInitials() || ''"
          [colorSeed]="userEmail()"
          class="main-layout__profile-trigger"
          role="button"
          tabindex="0"
          aria-haspopup="menu"
          aria-label="Open profile menu"
          (click)="popover.open()"
          (keydown.enter)="popover.open()"
          (keydown.space)="$event.preventDefault(); popover.open()"
        />
        <hlm-popover-content *hlmPopoverPortal="let ctx">
          <div class="embedded-layout__popover-content">
            @if (showLogout()) {
              <button hlmBtn type="button" (click)="onLogoutClick()">
                {{ 'auth.sign-out' | translate }}
              </button>
            }
            <ocp-theme-selector />
          </div>
        </hlm-popover-content>
      </hlm-popover>
    </div>
  </ocp-header>

  <main class="embedded-layout__content">
    <ng-content />
  </main>

  <footer class="embedded-layout__body-footer">
    <a
      class="embedded-layout__body-footer-link"
      [routerLink]="tocRoute"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ 'sidebar.early-access-program-agreement' | translate }}
    </a>
    <span class="embedded-layout__body-footer-separator" aria-hidden="true">|</span>
    <a
      class="embedded-layout__body-footer-link"
      [href]="imprintUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ 'sidebar.imprint' | translate }}
    </a>
  </footer>
</div>
